import { ComponentCreateRequestStatusCode } from '@gql/graphql';

export function humanizeRequestStatus(
    status: ComponentCreateRequestStatusCode,
): string {
    switch (status) {
        case ComponentCreateRequestStatusCode.Created:
            return 'Created';
        case ComponentCreateRequestStatusCode.Replaced:
            return 'Replaced';
        case ComponentCreateRequestStatusCode.Forwarded:
            return 'Forwarded';
        case ComponentCreateRequestStatusCode.Approved:
            return 'Approved';
        case ComponentCreateRequestStatusCode.Removed:
            return 'Removed';
        case ComponentCreateRequestStatusCode.ApprovalPending:
            return 'Unprocessed';
        default:
            return '-';
    }
}
